import script from "./LandingES.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingES.vue?vue&type=script&setup=true&lang=js"

import "./LandingES.vue?vue&type=style&index=0&id=257e9b5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-257e9b5a"]])

export default __exports__